import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from '../base_services/http_base.service';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { CommentsAggrigatorModel } from '@shared/model/comment-aggrigator-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { CommentDetailModel } from '@shared/model/comment-detail-model';
import { LikeAggrigatorModel } from '@shared/model/Activity_Aggtigator/like-aggrigator-model';
import { CommentModel } from '@shared/model/customerModels/comment-model';


@Injectable({
    providedIn: 'root'
})

export class CommentsAggrigatorService extends HttpBaseService {

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'v1/cmtAggr');
    }

    getCommentsByItemId(itemId: string, termFilter?: TermFilterModel): Observable<TServiceResult<PageList<CommentsAggrigatorModel>>> {
        const paramsValues = this.TermFilterParams(termFilter);
        return this.http.get<TServiceResult<PageList<CommentsAggrigatorModel>>>(`${this.apiUrl}/GetCommetsByItem/${itemId}${paramsValues}`);
    }

    getMessageDetailsById(itemId: string): Observable<TServiceResult<CommentDetailModel>> {
        return this.http.get<TServiceResult<CommentDetailModel>>(`${this.apiUrl}/GetMessageDetailsById/${itemId}`);
    }

    getCommetsWithRepliesByItem(itemId: string, termFilter?: TermFilterModel): Observable<TServiceResult<PageList<CommentsAggrigatorModel>>> {
        const paramsValues = this.TermFilterParams(termFilter);
        return this.http.get<TServiceResult<PageList<CommentsAggrigatorModel>>>(`${this.apiUrl}/GetCommetsWithRepliesByItem/${itemId}${paramsValues}`);
    }

    getReactionsByItem(itemId: string, termFilter?: TermFilterModel): Observable<TServiceResult<PageList<LikeAggrigatorModel>>> {
        const paramsValues = this.TermFilterParams(termFilter);
        return this.http.get<TServiceResult<PageList<LikeAggrigatorModel>>>(`${this.apiUrl}/GetReactionsByItem/${itemId}${paramsValues}`);
    }

    GetCommetWithRepliesById(commentId: string): Observable<TServiceResult<CommentsAggrigatorModel>> {
        return this.http.get<TServiceResult<CommentsAggrigatorModel>>(`${this.apiUrl}/GetCommetWithRepliesById/${commentId}`);
    }


    createComment(comment: CommentModel): Observable<TServiceResult<string>> {
        const removedSpace = comment.body?.trim();
        comment.body = removedSpace;
        return this.http.post<TServiceResult<string>>(`${this.apiUrl}/Comment`, comment);
    }

}
